export const STEPS_LIST = [
  {
    name: 'Name & description',
  },
  {
    name: 'Cost',
  },
  {
    name: 'Value',
    description: 'optional',
  },
  {
    name: 'Asset tags',
  },
  {
    name: 'Summary',
  },
]

export const TRANSACTION_TYPE = 'add position'
export const ACCOUNT_TYPE = 'grouping account'
export const ASSET_TYPE = 'property'

export const ASSET_CLASSES_LIST = ['Real Estate']

export const INVESTMENT_STRATEGIES_LIST = [
  'Personal Property',
  'Investment Property',
]
